<div class="accordion-item p-10">
  <div
    class="accordion-header row flex align-center justify-between"
    (click)="toggle()"
  >
    <div class="col-md-11">{{ title }}</div>
    <div
      class="cursor-pointer col-md-1"
      style="display: flex; justify-content: end"
    >
      <div>
        <space-icon [icon]="iconName" outline="false"> </space-icon>
      </div>
    </div>
  </div>
  <div class="accordion-body" *ngIf="isActive">
    <ng-content></ng-content>
  </div>
</div>
